import clsx from 'clsx';
import {Field, ErrorMessage} from 'formik';

import TextError from './TextError';

function Input(props: any) {
  const {label, name, labelOff = false, ...rest} = props;
  return (
    <div className='mb-7'>
      {!labelOff && (
        <label
          className={clsx('fw-bold fs-6 col-form-label', {required: props.required})}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      <Field id={name} name={name} {...rest}>
        {({form, meta}: any) => {
          return (
            <input
              {...form.getFieldProps(name)}
              {...rest}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                {'is-invalid': meta.touched && meta.error},
                {
                  'is-valid': meta.touched && !meta.error,
                }
              )}
              disabled={form.isSubmitting}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}

export default Input;
